import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3v7l3 -3","key":"svg-0"}],["path",{"d":"M9 7l3 3","key":"svg-1"}],["path",{"d":"M12 21v-7l3 3","key":"svg-2"}],["path",{"d":"M9 17l3 -3","key":"svg-3"}],["path",{"d":"M18 9h1a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-1","key":"svg-4"}],["path",{"d":"M6 9h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1","key":"svg-5"}]]

const IconViewportShort = createReactComponent('outline', 'viewport-short', 'ViewportShort', __iconNode);

export default IconViewportShort;